import { render, staticRenderFns } from "./CallWaiterDrawer.vue?vue&type=template&id=f98cd16e"
import script from "./CallWaiterDrawer.vue?vue&type=script&lang=js"
export * from "./CallWaiterDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports